'use strict';

require.config({
  paths: {
    // App-specific libraries
    'auth_popups'            : 'app/auth_popups',
    'checkAds'               : 'app/checkAds',
    'doublebracket'          : 'app/DoubleBracket',
    'FastAction'             : 'app/FastAction',
    'fastaction_config'      : 'app/fastaction_config',
    'databag_config'         : 'app/databag_config',
    'FormDefUtils'           : 'app/FormDefUtils',
    'FormError'              : 'app/FormError',
    'html2canvasWrapper'     : 'app/html2canvasWrapper',
    'NVTagCallbacks'         : 'app/NVTagCallbacks',
    'oberon'                 : 'app/oberon',
    'requestAutocomplete'    : 'app/requestAutocomplete',
    'trackTransaction'       : 'app/trackTransaction',
    'timing'                 : 'app/timing',
    'baseUrl'                : 'app/baseUrl',
    'assetUrl'               : 'app/assetUrl',
    'loadCSS'                : 'app/loadCSS',
    'loadScript'             : 'app/loadScript',
    'loadContent'            : 'app/loadContent',
    'loadResource'           : 'resources/loadResource',
    'otherOption'            : 'app/views/helpers/otherOption',
    'socialSharePopup'       : 'app/socialSharePopup',
    'strHelper'              : 'app/InPlaceofPolyfill',
    'socialMediaLogger'      : 'app/socialMediaLogger',
    'urlUtilities'           : 'app/urlUtilities',
    'Map'                    : 'app/Map',
    'ApplePay'               : 'app/applePay',
    'SignaturePad'           : 'app/SignaturePad',
    'vgs'                    : 'app/vgs',
    'recaptcha'              : 'app/recaptcha',
    'aliasHelper'            : 'app/aliasHelper',
    'deviceInfo'             : 'app/deviceInfo',
    'eaPayPal'               : 'app/eaPayPal',
    'matchPro'               : 'app/matchPro',
    'FormOptimizationExperiments': 'app/FormOptimizationExperiments',
    'FormOptimizationExperimentsLogic': 'app/FormOptimizationExperimentsLogic',
    'cookieConsentConfiguration': 'app/cookieConsentConfiguration',
    'googleAnalyticsHelper'  :  'app/googleAnalyticsHelper',

    // View libraries
    'formatRows'             : 'app/views/helpers/formatRows',
    'currency'               : 'app/views/helpers/currency',
    'lightboxHelper'         : 'app/views/helpers/lightboxHelper',
    'telemetry'              : 'app/views/helpers/telemetry',

    // App-specific static data
    'autocomplete'           : 'data/autocomplete',
    'countries'              : 'data/countries',
    'country.keys'           : 'data/country.keys',
    'occupations'            : 'data/occupations',
    'placeholder'            : 'data/placeholder',
    'prefixes'               : 'data/prefixes',
    'form.rows'              : 'data/form.rows',
    'states'                 : 'data/states',
    'qs.params'              : 'data/qs.params',

    // Models
    'databag'                : 'app/models/Databag',
    'profile_databag'        : 'app/models/ProfileDatabag',
    'fast_databag'           : 'app/models/FastDatabag',
    'fastActionUser'         : 'app/models/FastActionUser',
    'NVForm'                 : 'app/models/NVForm',
    'ContributionAmountModel': 'app/models/ContributionAmountModel',
    'ContributionRecurrenceModel' : 'app/models/ContributionRecurrenceModel',

    //Non form element views
    'PageAlertView'              : 'app/views/PageAlert',

    // Form Elements
    'FormElements'           : 'app/FormElements',
    'AdvocacyView'           : 'app/views/AdvocacyView',
    'AdvocacyTweetView'      : 'app/views/AdvocacyTweetView',
    'AdvocacyTweetsView'     : 'app/views/AdvocacyTweetsView',
    'AmountView'             : 'app/views/AmountView',
    'CaptchaView'            : 'app/views/CaptchaView',
    'CheckboxView'           : 'app/views/CheckboxView',
    'ContributionView'       : 'app/views/ContributionView',
    'VgsTextFieldView'       : 'app/views/VgsTextFieldView',
    'CreditCardView'         : 'app/views/CreditCardView',
    'CVV2View'               : 'app/views/CVV2View',
    'CCExpirationView'       : 'app/views/CCExpirationView',
    'DateView'               : 'app/views/DateView',
    'EcardsView'             : 'app/views/EcardsView',
    'EventInformationView'   : 'app/views/EventInformationView',
    'errorviews'             : 'app/views/ErrorViews',
    'FastActionView'         : 'app/views/FastActionView',
    'FieldsetView'           : 'app/views/FieldsetView',
    'FieldView'              : 'app/views/FieldView',
    'HiddenView'             : 'app/views/HiddenView',
    'MarkupView'             : 'app/views/MarkupView',
    'NotMeView'              : 'app/views/NotMeView',
    'MatchProView'           : 'app/views/MatchProView',
    'NVTagView'              : 'app/views/NVTagView',
    'NVFormView'             : 'app/views/NVFormView',
    'PaymentInformationView' : 'app/views/PaymentInformationView',
    'PaymentMethodView'      : 'app/views/PaymentMethodView',
    'PremiumGiftsView'       : 'app/views/PremiumGiftsView',
    'ActivistCodeQuestionView': 'app/views/ActivistCodeQuestionView',
    'CheckboxListManagerView': 'app/views/CheckboxListManagerView',
    'RadiosView'             : 'app/views/RadiosView',
    'RecipientInformationView' : 'app/views/RecipientInformationView',
    'ReCaptchaView'          : 'app/views/ReCaptchaView',
    'SelectView'             : 'app/views/SelectView',
    'ShippingInformationView': 'app/views/ShippingInformationView',
    'TargetsView'            : 'app/views/TargetsView',
    'TargetSelectView'       : 'app/views/TargetSelectView',
    'TextAreaView'           : 'app/views/TextAreaView',
    'TextFieldView'          : 'app/views/TextFieldView',
    'TicketHolderView'       : 'app/views/TicketHolderView',
    'TicketingLevelView'     : 'app/views/TicketingLevelView',
    'TicketingView'          : 'app/views/TicketingView',
    'TimeView'               : 'app/views/TimeView',
    'TrackingPixelView'      : 'app/views/TrackingPixelView',
    'TributeGiftView'        : 'app/views/TributeGiftView',
    'InternationalPhoneView' : 'app/views/InternationalPhoneView',
    'CoverCostsCheckboxView' : 'app/views/CoverCostsCheckboxView',
    'SignaturePadView'       : 'app/views/SignaturePadView',
    'EmployerOccupationRetiredCheckboxView': 'app/views/EmployerOccupationRetiredCheckboxView',

    //Re-usable libraries
    'jquery'                 : 'lib/jquery',
    'jquery.amd'             : 'lib/jquery.amd',
    'jquery.timepicker'      : 'lib/jquery.timepicker',
    'accounting'             : 'lib/accounting',
    'backbone'               : 'lib/backbone',
    'backbone.courier'       : 'lib/backbone.courier',
    'backbone.subviews'      : 'lib/backbone.subviews/backbone.subviews',
    'braintree'              : 'lib/braintree',
    'paypal'                 : 'lib/paypal',
    'PayPalCommercePlatform' : 'lib/PayPalCommercePlatform',
    'select2'                : 'lib/select2',
    'hbs'                    : 'lib/require-handlebars-plugin/hbs',
    'Handlebars'             : 'lib/require-handlebars-plugin/handlebars',
    'mailcheck'              : 'lib/mailcheck',
    'modal'                  : 'lib/hustle/modal',
    'moment'                 : 'lib/moment',
    'node-querystring'       : 'lib/node-querystring',
    'payment'                : 'lib/jquery.payment',
    'spin'                   : 'lib/spin',
    'underscore'             : 'lib/lodash.custom',
    'UAParser'               : 'lib/ua-parser',
    'ActionTagConfig'        : 'config/actionTagConfig',
    'uuid'                   : 'lib/uuid/uuid',
    'rng-browser'            : 'lib/uuid/rng-browser',
    'ActionTagGeneratedConfig' : 'config/config.generated', // default location, gets overwritten when bundled

    // Resources
    'PrimaryResources.resx'  : 'resources/PrimaryResources.resx', // Uses PrimaryResources.resx.js
    'Datepicker.resx'        : 'resources/Datepicker', // Uses Datepicker.js (not a typical resx)
    // Our own homegrown libraries
    'parseUrl'               : 'lib/parseUrl',

    // One time use add-ons
    'gtm': 'lib/gtm',

    // Testing libraries
    'chai'   : 'lib/chai/chai',
    'mocha'  : 'lib/mocha/mocha',
    'chance' : 'lib/chance',

    // Templates
    'templates': 'app/templates/all',

    'template-cc'     : 'templates/credit_card',
    'template-main'   : 'templates/main',
    'template-fa-modal'  : 'templates/fa-modal',
    'template-fa-confirm-account-modal': 'templates/fa-confirm-account-modal',
    'template-generic-modal' : 'templates/generic-modal'
  },
  waitSeconds: 10,
  hbs: {
    disableI18n: true,
    templateExtension: 'hbs',
    helperPathCallback: function (name) {
      return 'app/templates/_helpers/' + name;
    }
  }
});

// Avoid `console` errors in browsers that lack a console.
(function () {
  var noop = function(){};
  var logger = /^(dir(xml)?|error|info|warn)$/;
  var console = (window.console = window.console || {});
  var method, methods = [
    'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
    'exception', 'group', 'groupCollapsed', 'groupEnd', 'info',
    'profile', 'profileEnd', 'table', 'trace', 'warn',
    'markTimeline', 'time', 'timeEnd', 'timeStamp'
  ], length = methods.length;

  if (!console.log) {
    console.log = noop;
  }

  while (length--) {
    method = methods[length];
    if (!console[method]) { // Only stub undefined methods.
      console[method] = logger.test(method) ? console.log : noop;
    }
  }
})();

console.timeStamp('ActionTag parsed');

define("config", function(){});

